class CompareButton extends HTMLElement {
  compareBarUpdateUnsubscriber = undefined;


  constructor() {
    super();

    this.compareBar = document.querySelector('compare-bar');
    this.productId = this.dataset.id;
    this.inputElement = this.querySelector('input');
    this.isSelected = this.inputElement.checked;
    this.data = JSON.parse(this.querySelector('[type="application/json"]').textContent);
    this.imageSrc = this.closest('.custom-product__wrap').querySelector('.image__wrap img').src;

    this.checkIfSelected();
  }

  connectedCallback() {
    this.compareBarUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.compareBarUpdate, (event) => {
      if (event.action === 'remove' && event.id == this.productId) {
        this.inputElement.checked = false;
      }

      if(event.status == 'ok') {
        this.inputElement.disabled = false;
      }

      if (event.action === 'full' ) {
        this.inputElement.disabled = true;
      }
    });

    this.inputElement.addEventListener('change', this.changeHandler.bind(this));
  }

    disconnectedCallback() {
      if (this.compareBarUpdateUnsubscriber) {
        this.compareBarUpdateUnsubscriber();
      }
    }

  changeHandler(e) {
    if(! this.inputElement.checked) {
      publish(PUB_SUB_EVENTS.compareButtonUpdate, { action: 'remove', productId: this.productId });
    } 
    if(this.inputElement.checked) {
      publish(PUB_SUB_EVENTS.compareButtonUpdate, { action: 'add', productId: this.productId, imageSrc: this.imageSrc, data: this.data });
    }
  }

  checkIfSelected() {
    let compareItems = JSON.parse(localStorage.getItem('compare-items')) || [];
    let exists = compareItems.find(e => e.id == this.productId);
    if(exists) this.inputElement.checked = true;
    if(compareItems.length == 3) {
      this.inputElement.disabled = true;
    }
  }
}

if (!customElements.get('compare-button')) {
    customElements.define('compare-button', CompareButton);
}
